module.exports = new __parcel__URL__("mfa-push-notification.c5e46915.png").toString();